export const appConfig = {
    hideMenu: true,
    homePage: '/login',
};
